import { cn, getAccessibleTextColor } from '@risksmart-app/atomic-ui';
import type { ResolvedRating } from 'src/ratings/useRiskRatingResolver';

const NEUTRAL_BADGE_COLOR = '#E5E7EB';

interface RatingBadgeProps {
  rating: ResolvedRating | undefined;
  notRatedLabel: string;
  className?: string;
  testId?: string;
}

const RatingBadge = ({
  rating,
  notRatedLabel,
  className,
  testId,
}: RatingBadgeProps) => {
  if (!rating) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-sm whitespace-nowrap bg-muted text-muted-foreground',
          className
        )}
        data-testid={testId}
      >
        {notRatedLabel}
      </span>
    );
  }

  const backgroundColor = rating.color ?? NEUTRAL_BADGE_COLOR;
  const textColor = getAccessibleTextColor(backgroundColor);

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm whitespace-nowrap',
        className
      )}
      style={{ backgroundColor, color: textColor }}
      data-testid={testId}
    >
      {`${rating.label} (${rating.value})`}
    </span>
  );
};

export { RatingBadge };
